import type { ApiError } from '@approvalmax/types';
import { useQuery } from '@tanstack/react-query';
import { dataApi, schemas, stateTree } from 'modules/data';
import { hooks as pageHooks } from 'modules/page';
import { normalize } from 'normalizr';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { loadPageData } from '../actions';

export const loadWorkflows = async ({ companyId }: { companyId: string }) => {
    const result = await dataApi.templates.select({ companyId });

    return normalize<{ Templates: Array<typeof schemas.templateSchema> }, stateTree.Entities>(result, {
        Templates: [schemas.templateSchema],
    }).entities;
};

export const useWorkflowsListPageData = () => {
    const dispatch = useDispatch();
    const { companyId } = useParams<{ companyId: string }>();
    const { company } = pageHooks.useNonExistentCompanyError(companyId);

    const { isInitialLoading, error } = useQuery<stateTree.Entities, ApiError>(
        ['workflows_list', companyId],
        async () => await loadWorkflows({ companyId }),
        {
            enabled: !!company,
            onSuccess: (data) => {
                dispatch(loadPageData(companyId, data));
            },
        }
    );

    pageHooks.usePageError(error);

    return { isInitialLoading };
};
